// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ep3l","col":"styles_col__Ga4r2"};